import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { toast } from "react-toastify";

const Keywords = ({
  form,
  setForm,
  options: { title = "کلمات کلیدی سئو", key = "seoKeyword" },
}) => {

  const [word, setWord] = useState("");
  const addWordHandler = () => {
    console.log("sa");
    if (form[key]) {
      if (Array.isArray(form[key])) {
        if (form[key].length > 0) {
          if (form[key].includes(word)) {
            toast.error(" قبلا وارد شده است");
          } else {
            setForm({
              ...form,
              [key]: [...form[key], word].filter(Boolean),
            });
          }
        } else {
          setForm({
            ...form,
            [key]: [...form[key], word].filter(Boolean),
          });
        }
      } else {
        setForm({
          ...form,
          [key]: [word].filter(Boolean),
        });
      }

      setWord("");
    } else {
      setForm({
        ...form,
        [key]: [word].filter(Boolean),
      });
    }
    //  else {

    // }
  };
  const deleteWord = wo => {
    setForm({
      ...form,
      [key]: form[key]
        .map(ele => {
          if (ele != wo) {
            return ele;
          }
        })
        .filter(Boolean),
    });
  };
  const renderkeys = () => {
    if (Array.isArray(form[key])) {
      if (form[key].length != 0) {
        return form[key].map(item => {
          return (
            <button
              className="btn btn-outline-dark m-2"
              onClick={() => {
                deleteWord(item);
              }}
            >
              <span>{item}</span>
              <span style={{ marginRight: "10px" }}>
                <AiOutlineClose />
              </span>
            </button>
          );
        });
      } else {
        return <h6 className="fs-12 text-center fw-light">موردی یافت نشد</h6>;
      }
    } else {
      return <h6 className="fs-12 text-center fw-light">موردی یافت نشد</h6>;
    }
  };
  return (
    <div className="col-12 my-4">
      <div>
        <label className="labelinput mb-2">{title}</label>
        <div className="d-flex mb-2">
          <input
            className="form-control"
            placeholder={`${title} را وارد کنید`}
            onChange={({ target: { value } }) => {
              setWord(value);
            }}
            value={word}
            onKeyDown={e => {
              if (e.key == "Enter") {
                addWordHandler();
              }
            }}
          />
          <button className="btn btn-primary mr-2" onClick={addWordHandler}>
            ثبت
          </button>
        </div>
      </div>
      <div className="border rounded p-2">{renderkeys()}</div>
    </div>
  );
};

export default Keywords;
